<template>
  <div class="form-page">
    <v-card>
      <v-card-title>Vytvořit úklid</v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="handleSubmit">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="formData.address.value"
                label="Adresa*"
                :error-messages="errors.address"
                outlined
                filled
                dense
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.date"
                    label="Datum*"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors.date"
                    outlined
                    filled
                    dense
                    hide-details="auto"
                  />
                </template>
                <v-date-picker
                  v-model="formData.date"
                  :min="minDate"
                  @input="dateMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu
                ref="timeMenu"
                v-model="timeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.time"
                    label="Čas*"
                    prepend-icon="mdi-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors.time"
                    outlined
                    filled
                    dense
                    hide-details="auto"
                  />
                </template>
                <v-time-picker
                  v-model="formData.time"
                  format="24hr"
                  @input="timeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="serviceTypeId"
                :items="serviceTypeOptions"
                label="Typ služby*"
                :error-messages="errors.serviceTypeId"
                outlined
                filled
                dense
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="formData.repetition"
                :items="repetitionOptions"
                label="Opakování*"
                :error-messages="errors.repetition"
                outlined
                filled
                dense
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="formData.objectSizeKey"
                :items="objectSizeOptions"
                label="Velikost objektu*"
                :error-messages="errors.objectSizeKey"
                outlined
                filled
                dense
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="formData.additionalServices"
                :items="additionalServicesOptions"
                label="Doplnkové služby"
                multiple
                chips
                :error-messages="errors.additionalServices"
                outlined
                filled
                dense
                hide-details="auto"
              />
            </v-col>
          </v-row>
            <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="formData.extraCleaningHours"
                :items="extraCleaningHours"
                label="Přidané hodiny*"
                :error-messages="errors.extraCleaningHours"
                outlined
                filled
                dense
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="formData.hasDetergents"
                label="Má detergenty?"
                hide-details="auto"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="formData.hasCleaningItems"
                label="Má čistící potřeby?*"
                hide-details="auto"
                :error-messages="errors.hasCleaningItems"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="formData.note"
                label="Poznámka"
                outlined
                filled
                dense
                auto-grow
                hide-details="auto"
              />
            </v-col>
          </v-row>
           <!-- Total Duration Display -->
          <v-row>
            <v-col cols="12">
              <v-card outlined class="pa-3 mb-3">
                <v-card-subtitle class="pb-1">Celková doba úklidu</v-card-subtitle>
                <v-card-text class="pt-1">
                  <div class="text-h6 primary--text">
                    {{ totalDuration }} hodin
                  </div>
                  <div class="text-caption text--secondary mt-1">
                    <div v-if="objectSizeDuration">Základní doba ({{ getObjectSizeText() }}): {{ objectSizeDuration.toFixed(1) }}h</div>
                    <div v-if="formData.extraCleaningHours > 0">Přidané hodiny: {{ Number(formData.extraCleaningHours).toFixed(1) }}h</div>
                    <div v-if="additionalServicesDuration > 0">Doplňkové služby: {{ additionalServicesDuration.toFixed(1) }}h</div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              color="primary"
              outlined
              class="mx-1"
              to="/app/cleaning-services"
            >
              Zrušit
            </v-btn>
            <v-btn
              color="primary"
              type="submit"
              :loading="isSubmitting"
              :disabled="isSubmitting"
              class="mx-1"
              @click="handleSubmit"
            >
              Vytvořit objednávku
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import {generateRequestParams} from '@/helper/global-helper'
export default {
  name: 'NewOrderForm',
  data() {
    return {
      formData: {
        address: {
          value: ''
        },
        date: '',
        time: '',
        repetition: null,
        objectSizeKey: null,
        hasDetergents: false,
        hasCleaningItems: false,
        extraCleaningHours: 0,
        promoCode: '',
        note: '',
        additionalServices: []
      },
      errors: {
        address: [],
        date: [],
        time: [],
        repetition: [],
        objectSizeKey: [],
        additionalServices: [],
        extraCleaningHours: [],
        serviceTypeId: []
      },
      isSubmitting: false,
      dateMenu: false,
      timeMenu: false,
      repetitionOptions: [
        { text: 'Jednorázově', value: 'onetime' },
        { text: 'Týdně', value: 'weekly' },
        { text: 'Jednou za 2 týdny', value: 'biweekly' },
        { text: 'Měsíčně', value: 'monthly' },
      ],
      objectSizeOptions: [
        { text: 'Malý', value: 'small' },
        { text: 'Střední', value: 'medium' },
        { text: 'Velký', value: 'large' }
      ],
      additionalServicesOptions: [],
      extraCleaningHours: Array.from({ length: 21 }, (_, i) => ({
        text: `${i * 0.5}h`,
        value: (i * 0.5).toString()
      })),
      floor: '',
      serviceTypeId: null, // Will be fetched from backend
      serviceTypes: []
    }
  },
  computed: {
    minDate() {
      return new Date().toISOString().substr(0, 10)
    },
    serviceTypeOptions() {
      const labels = {
        'cleaning': 'Úklid',
        'carpet_beating': 'Vytloukání koberců',
        'general_cleaning': 'Generální úklid'
      }
      return this.serviceTypes.map(st => ({
        text: labels[st.serviceName] || st.name || st.serviceName,
        value: st._id
      }))
    },
    objectSizeDuration() {
      const sizeHours = {
        'small': 3,
        'medium': 4,
        'large': 5
      }
      return this.formData.objectSizeKey ? sizeHours[this.formData.objectSizeKey] : 0
    },
    additionalServicesDuration() {
      if (!this.formData.additionalServices || !Array.isArray(this.formData.additionalServices)) {
        return 0
      }
      
      return this.formData.additionalServices.reduce((total, serviceId) => {
        const service = this.additionalServicesOptions.find(s => s.value === serviceId)
        return total + (service?.duration / 60 || 0)
      }, 0)
    },
    totalDuration() {
      const objectSize = this.objectSizeDuration
      const extraHours = Number(this.formData.extraCleaningHours) || 0
      const additionalServices = this.additionalServicesDuration
      
      return (objectSize + extraHours + additionalServices).toFixed(1)
    }
  },
  mounted() {
    this.fetchAdditionalServices()
    this.fetchServiceTypes()
  },
  methods: {
    async fetchServiceTypes() {
      try {
        const params = generateRequestParams(0, 50, null, 'asc')
        const { data } = await this.axios.get('v1/service-types', { params })
        console.log('Service types response:', data)
        this.serviceTypes = data.data || data || []
        console.log('Service types:', this.serviceTypes)
        // Find the cleaning service type and set it as default
        const cleaningService = this.serviceTypes.find(st =>
          st.serviceName === 'cleaning' || st.serviceName === 'Cleaning'
        )
        if (cleaningService) {
          this.serviceTypeId = cleaningService._id
        } else if (this.serviceTypes.length > 0) {
          this.serviceTypeId = this.serviceTypes[0]._id
        }
      } catch (error) {
        console.error('Failed to fetch service types:', error)
        this.$store.commit('addAlert', {
          type: 'error',
          message: 'Nepodařilo se načíst typy služeb'
        })
      }
    },
    async fetchAdditionalServices() {
      const params = generateRequestParams(
        0,
        50,
        null,
        "asc"
      )
      this.axios.get('v1/additional-services', {
        params
      })
        .then(({ data }) => {
            console.log(data)
            this.additionalServicesOptions = data.data.map(service => ({
              text: service.name,
              value: service._id,
              duration: service.duration || 0
            }))
          })
    },
    validateForm() {
      this.errors = {
        address: [],
        date: [],
        time: [],
        repetition: [],
        objectSizeKey: [],
        additionalServices: [],
        extraCleaningHours: [],
        serviceTypeId: []
      }

      let isValid = true

      if (!this.formData.address.value) {
        this.errors.address.push('Addresa je povinná')
        isValid = false
      }

      if (!this.formData.date) {
        this.errors.date.push('Datum je povinné')
        isValid = false
      }

      if (!this.formData.time) {
        this.errors.time.push('Čas je povinný')
        isValid = false
      }

      if (!this.formData.repetition) {
        this.errors.repetition.push('Opakování je povinné')
        isValid = false
      }

      if (!this.formData.objectSizeKey) {
        this.errors.objectSizeKey.push('Velikost objektu je povinná')
        isValid = false
      }

      if (!this.serviceTypeId) {
        this.errors.serviceTypeId.push('Typ služby je povinný')
        isValid = false
      }

      if (!this.formData.hasCleaningItems) {
        this.errors.hasCleaningItems = ['Čistící potřeby jsou povinné']
        this.$store.commit('addAlert', {
          type: 'error',
          message: "Čistící potřeby jsou povinné"
        })
        isValid = false
      }

      return isValid
    },
    async handleSubmit() {
      console.log('Form submitted')
      if (!this.validateForm()) {
        console.log('Form validation failed')
        return
      }

      this.isSubmitting = true

      // Build repeatInfo in the correct format
      let repeatInfo = undefined
      if (this.formData.repetition !== 'onetime') {
        repeatInfo = {
          repeatPeriodAmount: this.formData.repetition === 'biweekly' ? 2 : 1,
          repeatPeriodValue: this.formData.repetition === 'biweekly' || this.formData.repetition === 'weekly' ? 'weeks' : 'months'
        }
      }

      // Build additionalServices array with just _id
      const additionalServices = this.formData.additionalServices?.map(serviceId => ({
        _id: serviceId
      })) || []

      // Prepare the data in the new Order format
      const submitData = {
        serviceTypeId: this.serviceTypeId,
        date: new Date(`${this.formData.date}T${this.formData.time}`).toISOString(),
        note: this.formData.note,
        promoCode: this.formData.promoCode || undefined,
        serviceData: {
          address: {
            value: this.formData.address.value
          },
          objectSizeKey: this.formData.objectSizeKey,
          hasDetergents: this.formData.hasDetergents,
          additionalServices: additionalServices,
          repeatInfo: repeatInfo,
          extraCleaningHours: Number(this.formData.extraCleaningHours) || 0
        }
      }

      this.axios.post('/v1/cleaning-orders/create-admin', submitData)
        .then(() => {
          this.$store.commit('addAlert', {
            type: 'success',
            message: 'Objednávka byla úspěšně vytvořena'
          })
          this.$router.push('/app/cleaning-services')
        })
        .catch((error) => {
          console.error('Create order error:', error.response?.data || error)
          this.$store.commit('addAlert', {
            type: 'error',
            message: error.response?.data?.message || 'Chyba při vytváření objednávky'
          })
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    getObjectSizeText() {
      const sizeTexts = {
        'small': 'Malý',
        'medium': 'Střední', 
        'large': 'Velký'
      }
      return this.formData.objectSizeKey ? sizeTexts[this.formData.objectSizeKey] : ''
    }
  }
}
</script>

<style scoped>
.form-page {
  padding: 24px;
  max-width: 800px;
  margin: 0 auto;
}
</style> 